export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 32;

const allowedPasswordCharacters = /^[\p{Letter}\p{Mark}0-9!@#$%&*-]+$/u;
const requiredPasswordSpecialCharacter = /[!@#$%&*-]/;

export function hasAllowedPasswordCharacters(password: string): boolean {
  return allowedPasswordCharacters.test(password);
}

export function hasRequiredPasswordSpecialCharacter(password: string): boolean {
  return requiredPasswordSpecialCharacter.test(password);
}
